import * as React from 'react';
import { useContext, useEffect } from 'react';
import LoadingScreen from '../../components/muiLegacy/LoadingScreen/LoadingScreen';
import { AuthenticationContext } from '../../logic/security/authentication/AuthenticationContext';

export interface CallbackProps {}

const AuthCallbackPage: React.FC<CallbackProps> = ({}) => {
  const authenticationContext = useContext(AuthenticationContext);
  useEffect(() => {
    authenticationContext.handleCallback();
  }, []);

  return <LoadingScreen />;
};

export default AuthCallbackPage;
